export enum TicketStatus {
  "answering" = "درحال بررسی",
  "answered" = "پاسخ داده شده",
  "closed" = "بسته شده",
}

type MessageType = {
  message: string // همیشه باید پر شود
}

type WithTitle = {
  title: string
  ticket_id?: never // ticket_id نباید وجود داشته باشد
}

type WithTicketId = {
  ticket_id: string
  title?: never // title نباید وجود داشته باشد
}

export enum TicketCategory {
  billing = "مالی ",
  account = "حساب کاربری",
  feature_request = "درخواست قابلیت جدید",
  general = "عمومی",
  feedback = "انتقادات و پیشنهادات",
  technical = "فنی",
}

export type Ticket = MessageType & (WithTitle | WithTicketId)

// ساختار تیکت دریافتی از سرور (نمونه پاسخ API)
export type TicketInfo = {
  id: number
  title: string
  is_esaj?: boolean | number
  status?: string
  created_at?: string
  category?: string
}
